export default __webpack_public_path__ + "static/media/product-preview-transparent.fad4f179.png";